import { Autopayment } from 'billing/mediators/billing-autopayment-mediator';

define([
    'jQuery',
    'Emitter',
    '../models/CreditCard',
    '../blocks/bind-credit-card/bind-credit-card',
], ($, Emitter, CreditCard, PaymentView) => {
    'use strict';

    function CreditCardCreator(options) {
        options || (options = {});

        this._radar =
            options.radar ||
            function radar() {
                return radar;
            };

        this._renderPayment();
    }

    CreditCardCreator.fn = CreditCardCreator.prototype = {
        _renderPayment() {
            this._bindCreditCardView = new PaymentView({
                renderMode: 'replace',
                el: $('<div/>').appendTo('.layers'),
                radar: this._radar,
            });

            this._bindCreditCardView.show();

            this._bindCreditCardView.setState('waiting');
            this._start();

            this._bindCreditCardView.on('hide', () => {
                this.emit('close');
            });

            this._bindCreditCardView.on('repeat', this._start.bind(this));

            this._bindCreditCardView.on('paySuccess', () => {
                if (this.destroyed) {
                    return;
                }
                this.emit('paySuccess');
                this._bindCreditCardView.hideAutopaymentManual();
                this._bindCreditCardView.showAutopaymentSpinner();
                this._bindCreditCardView.activateTab('autopayment');
            });
        },

        showAutopaymentSettings() {
            if (!this.destroyed) {
                this._renderAutopaymentSettings();
                this._bindCreditCardView.hideAutopaymentSpinner();
                this._bindCreditCardView.activateTab('autopayment');
            }
        },

        _renderAutopaymentSettings() {
            if (this._autopayment) {
                this._autopayment.destroy();
                this._autopayment = null;
            }

            this._autopayment = new Autopayment({
                enabled: true,
                stretched: true,
            });
            this._autopayment.on('settingsChanged', () => {
                this.emit('autopaymentSettingsChanged');
            });
            this._autopayment.renderTo(
                this._bindCreditCardView.getAutopaymentSettingsContainer(),
            );
        },

        _start() {
            this._getPaymentGateURL()
                .then((url) => {
                    this._bindCreditCardView.goToPayment(url);
                })

                .catch(() => {
                    this._bindCreditCardView.setError();
                });
        },

        _getPaymentGateURL() {
            return CreditCard.getBindingGateURL();
        },

        isErrorState() {
            return this._bindCreditCardView.isErrorState();
        },

        isSuccess() {
            return this._bindCreditCardView.isSuccess();
        },

        destroy() {
            if (this._autopayment) {
                this._autopayment.destroy();
                this._autopayment = null;
            }

            if (this._bindCreditCardView) {
                this._bindCreditCardView.close();
                this._bindCreditCardView = null;
            }

            this.destroyed = true;
        },
    };

    Emitter.apply(CreditCardCreator.fn);

    return CreditCardCreator;
});
